<template>
  <div class="fixed left-0 top-0 w-screen z-50 bg-black">
    <div class="flex items-center p-2 relative z-50 justify-between">
      <div class="flex items-center">
        <div class="mr-2" :class="navIconClassList" @click="active = !active">
          <span class="nav-icon__line"></span>
        </div>
        <router-link
          class="text-xl font-bold glitch"
          to="/"
          data-text="NoSleep Stories"
        >
          NoSleep Stories
        </router-link>
      </div>
      <div class="pr-2">
        <template v-if="loggedInUser">
          <span class="mr-3">{{loggedInUser.name}}</span>
          <button type="button" @click.prevent="signOut">Sign out</button>
        </template>
        <nav v-else>
          <router-link to="login" class="mr-4">Login</router-link>
          <router-link to="register">Register</router-link>
        </nav>
      </div>
    </div>
    <div class="z-10" :class="navContainerClassList">
      <nav class="nav">
        <router-link to="/" class="router-link">Home</router-link>
        <router-link to="/about" class="router-link">About</router-link>
        <router-link v-if="isAdmin" to="/story/new" class="router-link">New Story</router-link>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import firebase from 'firebase/app';

export default {
  name: 'Navigation',
  data() {
    return {
      active: false,
    };
  },
  watch: {
    '$route'() { // eslint-disable-line
      this.active = false;
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      loggedInUser: 'users/loggedInUser'
    }),
    isAdmin() {
      return this.loggedInUser && this.loggedInUser.role === 'admin';
    },
    navContainerClassList() {
      return {
        'nav-container': true,
        '-active': this.active,
      };
    },
    navIconClassList() {
      return {
        'nav-icon': true,
        '-active': this.active,
      };
    },
  },
  methods: {
    signOut() {
      firebase.auth().signOut();
    }
  }
};
</script>

<style lang="scss">
.nav {
  font-size: 18px;
  margin-bottom: 1rem;

  a {
    color: currentColor;

    &.router-link {
      display: block;
      font-weight: bold;
      text-decoration: none;

      &:hover,
      &-exact-active {
        color: #68D391;
      }

      &:not(:last-child) {
        margin-bottom: 0.5rem;
      }
    }
  }

  &-container {
    padding: 5rem 1rem 1rem;
    background-color: inherit;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 15rem;
    display: flex;
    flex-direction: column;
    transition-property: transform, box-shadow;
    transition-duration: 0.4s;
    transition-timing-function: ease-in-out;

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 100%;
      height: 100%;
      width: 100vw;
      background-color: rgba(#1a202c, 0.95);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.5s ease-in-out, visibility 0.5s ease-in-out;
    }

    &.-active {
      box-shadow: 1rem 0 4rem #1a202c;

      &:before {
        visibility: visible;
        opacity: 0.9;
      }
    }

    &:not(.-active) {
      transform: translateX(-100%);
    }
  }

  &-icon{
    height: 14px;
    width: 24px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 17px 12px;
    box-sizing: content-box;

    &:hover, &.-active {
      color: #68D391;
    }

    &:before, &:after, &__line {
      height: 2px;
      display: block;
      background-color: currentColor;
      transition:
        transform .2s ease,
        background-color .5s ease,
        width .2s ease;
    }

    &:before, &:after {
      content: '';
      width: 60%;
    }

    &:after {
      align-self: flex-end;
    }

    &.-active {
      .nav-icon__line{
        transform: rotate(-45deg);
      }

      &:before {
        width: 50%;
        transform: translate(2px, 2px) rotate(45deg);
      }

      &:after {
        width: 50%;
        transform: translate(-2px, -2px) rotate(45deg);
      }
    }
  }
}
</style>
